// cSpell:ignore Español
import { i18nextCreator } from 'utils';
import englishTranslation from './i18n-en.json';
import spanishTranslation from './i18n-es.json';

interface Language {
  nativeName: string;
}

export const languages: { [key: string]: Language } = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Español' },
};

const IS_LOCAL = false;

const i18n = i18nextCreator(
  {
    en: {
      translation: englishTranslation as any,
    },
    es: {
      translation: spanishTranslation as any,
    },
  },
  IS_LOCAL
);

export default i18n;
